export const headCells = [
  //for zero(0) index for Trust/Customers
  [{
    id: 'id',
    label: 'Id',
    sortable: false,
    align: 'left',
    numIndex: 0,
    width: '2%',
    activeIndexOnly: true,
  },
  {
    id: 'name',
    label: 'Customer Name',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: '20%',
    activeIndexOnly: true,
  },
  {
    id: 'customerCode',
    label: 'Customer Code',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: '10%',
    activeIndexOnly: true,
  },
  {
    id: 'Framework',
    label: 'Framework',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: '20%',
    activeIndexOnly: true,
  },
  {
    id: 'lastUpdated',
    label: 'Last Updated By',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: '30%',
    activeIndexOnly: true,
  },
  {
    id: 'lastUpdated',
    label: 'Last Updated',
    sortable: true,
    align: 'left',
    numIndex: 0,
    width: '30%',
    activeIndexOnly: true,
  },

    // {
    //   id: 'Invoice',
    //   label: 'Action',
    //   sortable: false,
    //   align: 'center',
    //   width: '1%',
    //   numIndex: 0,
    //   activeIndexOnly: true,
    // },
  ],


]
